<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded" role="doc-dedication">
<p class="dedf"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span>This anthology is dedicated to the memory of Carrie Fisher in all her guises: writer, mental health advocate, comedian, feminist activist, Princess Leia, and Space Mom.</p>
<hr class="sec-break"/>
<p class="sec">✴♦✴</p>
<p class="ded">It is also dedicated to the fans and community her presence inspired to keep fighting to flip off the world another day.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-midejewski-0006.vue?31ffd596